import PropTypes from 'prop-types';
import { FormGroup, Label, Select } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './NodePicker.module.scss';

const NodePicker = ({ value, onChange, options, disabled }) => (
  <div className={styles.nodeField}>
    <FormGroup>
      <Label size="sm" for={credentialForm.nodePickerId}>
        {credentialForm.nodePickerLabel}
      </Label>
      <Select
        size="sm"
        id={credentialForm.nodePickerId}
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
      />
    </FormGroup>
  </div>
);

NodePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  disabled: PropTypes.bool,
};

NodePicker.defaultProps = {
  value: '',
  onChange: noop,
  options: [],
  disabled: false,
};

export default NodePicker;
